import { render } from "./SelectableFields.vue?vue&type=template&id=55727e04&scoped=true&lang=pug"
import script from "./SelectableFields.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectableFields.vue?vue&type=script&setup=true&lang=js"

import "./SelectableFields.vue?vue&type=style&index=0&id=55727e04&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55727e04"]])

export default __exports__